import ReactMarkdown from "react-markdown"
import PropTypes from "prop-types"

const MarkdownRenderer = ({ content }) => {
  return (
    <ReactMarkdown
      className="text-sm prose dark:prose-invert max-w-none prose-sm"
      components={{
        p: ({ node, ...props }) => <p className="mb-1" {...props} />,
        a: ({ node, ...props }) => (
          <a
            className="text-blue-500 hover:underline"
            {...props}
            target="_blank"
            rel="noopener noreferrer"
          />
        ),
        ul: ({ node, ...props }) => (
          <ul className="list-disc ml-4 mb-2" {...props} />
        ),
        ol: ({ node, ...props }) => (
          <ol className="list-decimal ml-4 mb-2" {...props} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  )
}

MarkdownRenderer.propTypes = {
  content: PropTypes.string.isRequired,
}

export default MarkdownRenderer
